import { GetData } from "../Api";
import { useEffect, useState, useContext } from "react";
import { startOfDay, endOfDay } from "date-fns";
import {factoryStartEndTime} from '../Hooks/Common'
import FactoryLine from "../Components/FactoryLine";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import FilterContext from "../Hooks/Context";
import Filter from "../Components/Filter";

const FactoryOverview = () => {
  const filterQueries = useContext(FilterContext);
  const [menuStatus, SetMenuStatus] = useState(false);
  const [factoryLineData, SetFactoryLineData] = useState();
  const [lineDataVisiblity, SetLineDataVisiblity] = useState(true);
  const [startDate, SetStartDate] = useState(new Date(filterQueries.filterRequestQuery.startTs*1000));
  const [endDate, SetEndDate] = useState(new Date(filterQueries.filterRequestQuery.endTs*1000));
  const [liveStatus, SetLiveStatus] = useState(true);
  const { t } = useTranslation();

  const history = useHistory();

  const GetFactoryOverviewData = (factoryId) => {
    if (
      filterQueries &&
      filterQueries.filterRequestQuery !== null &&
      filterQueries.filterRequestQuery !== undefined
    ) {
      GetData(
        `factory/?factoryId=${factoryId}&startTs=${filterQueries.filterRequestQuery.startTs}&endTs=${filterQueries.filterRequestQuery.endTs}`
      )
        .then((response) => {
          return response.data;
        })
        .then((data) => {
          SetFactoryLineData(data);
        })
        .catch((error) => {
          // localStorage.removeItem("token");
          // localStorage.removeItem("refreshToken");
          // history.push("/");
          console.error("error - - - - - - - - -", error);
        });
    }
  };

  const NavigateLineData = (lineId) => {
    let filterRequestQuery = JSON.parse(JSON.stringify(filterQueries.filterRequestQuery));
    filterRequestQuery.selectedMenu = "#lineOverview";
    filterQueries.GenerateFilters(filterRequestQuery);
    history.push("/lineOverview");
  };

      /* Live Module Starts from Here */

      const [pauseLive, SetPauseLive] = useState(false);
      const [timeInterval, setTimeInterval] = useState(0);
      var timeout, timeIntervalCount;
    
      const EnableLiveData = (event) => {
        SetPauseLive(false);
        let fset = factoryStartEndTime()
        let startDate = fset.startTs
        let endDate = fset.endTs
      
        let filterRequestQuery = JSON.parse(JSON.stringify(filterQueries.filterRequestQuery));
        filterRequestQuery.isLive = true;
        filterRequestQuery.startTs = startDate;
        filterRequestQuery.endTs = endDate;
        filterQueries.GenerateFilters(filterRequestQuery);
      }
    
      useEffect(() => {
        if(!pauseLive) {
          timeout = setTimeout(() => {
            timeIntervalCount = setTimeInterval(timeInterval + 1);
            }, 60000);
        }
      });
    
      useEffect(() => {
        if (filterQueries) {
          GetFactoryOverviewData('');
        }
      },[ filterQueries ]);
    
      useEffect(() => {
        if(filterQueries.filterRequestQuery.isLive) {
          SetPauseLive(false);
        } else {
          SetPauseLive(true);
        }
      },[ filterQueries.filterRequestQuery ]);
    
      useEffect(() => {
        if(filterQueries.filterRequestQuery.isLive) {
          let filterRequestQuery = JSON.parse(JSON.stringify(filterQueries.filterRequestQuery));
          filterRequestQuery.isLive = true;
          filterQueries.GenerateFilters(filterRequestQuery);
        } else {
          let filterRequestQuery = JSON.parse(JSON.stringify(filterQueries.filterRequestQuery));
          filterRequestQuery.isLive = false;
          filterQueries.GenerateFilters(filterRequestQuery);
          clearTimeout(timeout);
          clearInterval(timeIntervalCount);
        }
        
      }, [timeInterval]);
    
      /* Live Module Ends from Here */

  useEffect(() => {
    GetFactoryOverviewData('');
    let filterRequestQuery = JSON.parse(JSON.stringify(filterQueries.filterRequestQuery));
    filterRequestQuery.selectedMenu = "#factoryOverview";
    filterQueries.GenerateFilters(filterRequestQuery);
  }, []);

  return (
    <>
      <h4>{ t("LT_factory_overview") }</h4>
      { !pauseLive && (
        <span className="liveStatus">
          { t("LT_live") }{" "}
          <span
            className={`showLive ${liveStatus ? "live-icon" : "relay"}`}
          ></span>
        </span>
      )}
      { pauseLive && <div className='live-btn' onClick={ (event) => { EnableLiveData(event) } }>{t("LT_enable_live_data")}</div>}
      <Filter showDatePicker={false} startDate={startDate} endDate={endDate} />
      {factoryLineData && (
        <FactoryLine data={factoryLineData} getLineData={NavigateLineData} />
      )}
    </>
  );
};

export default FactoryOverview;
